export function getRussianRegions() {
    return [
        ["RU-MOW", "Москва", 3],
        ["RU-SPE", "Санкт-Петербург", 3],
        ["RU-AD", "Республика Адыгея", 3],
        ["RU-AL", "Республика Алтай", 7],
        ["RU-BA", "Республика Башкортостан", 5],
        ["RU-BU", "Республика Бурятия", 8],
        ["RU-DA", "Республика Дагестан", 3],
        ["RU-IN", "Республика Ингушетия", 3],
        ["RU-KB", "Кабардино-Балкарская Республика", 3],
        ["RU-KL", "Республика Калмыкия", 3],
        ["RU-KC", "Карачаево-Черкесская Республика", 3],
        ["RU-KR", "Республика Карелия", 3],
        ["RU-KO", "Республика Коми", 3],
        ["RU-ME", "Республика Марий Эл", 3],
        ["RU-MO", "Республика Мордовия", 3],
        ["RU-SA", "Республика Саха(Якутия)", 10],
        ["RU-SE", "Республика Северная Осетия — Алания", 3],
        ["RU-TA", "Республика Татарстан", 3],
        ["RU-TY", "Республика Тыва", 7],
        ["RU-UD", "Удмуртская Республика", 4],
        ["RU-KK", "Республика Хакасия", 7],
        ["RU-CE", "Чеченская Республика", 3],
        ["RU-CU", "Чувашская Республика", 3],
        ["RU-ALT", "Алтайский край", 7],
        ["RU-ZAB", "Забайкальский край", 9],
        ["RU-KAM", "Камчатский край", 12],
        ["RU-KDA", "Краснодарский край", 3],
        ["RU-KYA", "Красноярский край", 7],
        ["RU-PER", "Пермский край", 5],
        ["RU-PRI", "Приморский край", 10],
        ["RU-STA", "Ставропольский край", 3],
        ["RU-KHA", "Хабаровский край", 10],
        ["RU-AMU", "Амурская область", 9],
        ["RU-ARK", "Архангельская область", 3],
        ["RU-AST", "Астраханская область", 4],
        ["RU-BEL", "Белгородская область", 3],
        ["RU-BRY", "Брянская область", 3],
        ["RU-VLA", "Владимирская область", 3],
        ["RU-VGG", "Волгоградская область", 3],
        ["RU-VLG", "Вологодская область", 3],
        ["RU-VOR", "Воронежская область", 3],
        ["RU-IVA", "Ивановская область", 3],
        ["RU-IRK", "Иркутская область", 8],
        ["RU-KGD", "Калининградская область", 2],
        ["RU-KLU", "Калужская область", 3],
        ["RU-KEM", "Кемеровская область", 7],
        ["RU-KIR", "Кировская область", 3],
        ["RU-KOS", "Костромская область", 3],
        ["RU-KGN", "Курганская область", 5],
        ["RU-KRS", "Курская область", 3],
        ["RU-LEN", "Ленинградская область", 3],
        ["RU-LIP", "Липецкая область", 3],
        ["RU-MAG", "Магаданская область", 10],
        ["RU-MOS", "Московская область", 3],
        ["RU-MUR", "Мурманская область", 3],
        ["RU-NIZ", "Нижегородская область", 3],
        ["RU-NGR", "Новгородская область", 3],
        ["RU-NVS", "Новосибирская область", 6],
        ["RU-OMS", "Омская область", 6],
        ["RU-ORE", "Оренбургская область", 5],
        ["RU-ORL", "Орловская область", 3],
        ["RU-PNZ", "Пензенская область", 3],
        ["RU-PSK", "Псковская область", 3],
        ["RU-ROS", "Ростовская область", 3],
        ["RU-RYA", "Рязанская область", 3],
        ["RU-SAM", "Самарская область", 4],
        ["RU-SAR", "Саратовская область", 3],
        ["RU-SAK", "Сахалинская область", 11],
        ["RU-SVE", "Свердловская область", 5],
        ["RU-SMO", "Смоленская область", 3],
        ["RU-TAM", "Тамбовская область", 3],
        ["RU-TVE", "Тверская область", 3],
        ["RU-TOM", "Томская область", 6],
        ["RU-TUL", "Тульская область", 3],
        ["RU-TYU", "Тюменская область", 5],
        ["RU-ULY", "Ульяновская область", 4],
        ["RU-CHE", "Челябинская область", 5],
        ["RU-YAR", "Ярославская область", 3],        
        ["RU-YEV", "Еврейская автономная область", 10],
        ["RU-NEN", "Ненецкий автономный округ", 3],
        ["RU-KHM", "Ханты-Мансийский автономный округ — Югра", 5],
        ["RU-CHU", "Чукотский автономный округ", 12],
        ["RU-YAN", "Ямало-Ненецкий автономный округ", 5],
        ["RU-YAN", "Республика Крым", 3],
        ["RU-YAN", "Севастополь", 3],
    ];
    }